import { channels } from '@/mocks/data';

export default function LiveChannels() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              直播频道
            </h2>
            <p className="text-foreground-600 text-base">
              实时观看热门电视频道，精彩节目不错过
            </p>
          </div>
          <a href="#" className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
            查看全部频道
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {channels.map((channel) => (
            <div
              key={channel.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-5 flex items-center gap-4 transition-all duration-300 hover:border-primary-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={`${channel.logo} text-2xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-medium text-foreground-900 text-sm truncate">
                    {channel.name}
                  </h3>
                  {channel.isLive && (
                    <span className="flex-shrink-0 px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-full font-medium whitespace-nowrap">
                      直播中
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-600 truncate">{channel.currentProgram}</p>
                {channel.viewers > 0 && (
                  <p className="text-xs text-foreground-400 mt-1">
                    <i className="ri-eye-line mr-1"></i>
                    {(channel.viewers / 10000).toFixed(0)}万人观看
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}